module.exports = __webpack_public_path__ + "static/media/gracias.3a585142.jpg";